import { RouteRecordRaw } from 'vue-router';

const usesRoutes: RouteRecordRaw[] = [
  {
    path: '/uses/industry',
    name: 'uses-industry',
    component: () => import(/* webpackChunkName: "uses-industry" */ '@/views/uses/IndustryView.vue'),
    meta: {
      title: 'Industry Uses',
      requiresAuth: false,
    },
  },
  // {
  //   path: '/uses/success-stories',
  //   name: 'uses-success-stories',
  //   component: () => import(/* webpackChunkName: "uses-success-stories" */ '@/views/uses/SuccessStoriesView.vue'),
  //   meta: {
  //     title: 'Success Stories',
  //     requiresAuth: false,
  //   },
  // },
  // {
  //   path: '/uses/research',
  //   name: 'uses-research',
  //   component: () => import(/* webpackChunkName: "uses-research" */ '@/views/uses/ResearchView.vue'),
  //   meta: {
  //     title: 'Research',
  //     requiresAuth: false,
  //   },
  // },
];

export default usesRoutes;